import { render } from "./LikeSvg.vue?vue&type=template&id=b3c0e90c"
import script from "./LikeSvg.vue?vue&type=script&lang=js"
export * from "./LikeSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__